import { provideApolloClient } from "@vue/apollo-composable";
import { effectScope } from "vue";
import { apolloClient } from "@/utils/apolloClient";
import {gqlGetClientInfo} from "@/graphql/clients";

export const hasNoTargetRetirementAge = async ({ params }) => {
    const scope = effectScope(true);

    try {
        return await scope.run(async () => {
            provideApolloClient(apolloClient);

            try {
                const response = await apolloClient.query({
                    query: gqlGetClientInfo,
                    fetchPolicy: 'no-cache',
                });

                const clientInfo = response
                    ?.data
                    ?.clientInfo

                const hasTargetRetirementAge = clientInfo?.targetRetirementAge

                if (!hasTargetRetirementAge && params?.portfolioId) {
                    return `/pension/onboarding/${params.portfolioId}`
                }

                return true
            } catch (error) {
                console.error('Query error:', error);
                return false
            }
        });
    } finally {
        scope.stop();
    }
};